// 仓储方认证页面参数管理
export class TabParam {
  constructor() {
    this.listQuery = { // 查询参数
      companyType: undefined, // 认证类型
      auditStatus: undefined, // 审核状态
      companyName: undefined, // 公司名称
      startCreateDate: undefined, // 报审时间
      endCreateDate: undefined // 报审时间
    }
  }
  listQuery;
  // Page;
}

export class FormParam {
  constructor() {
    this.dataForm = {
      id: null,
      userId: null, // 用户Id
      companyType: this.roles, // 公司类型 1：货源方 2：运力方  3：仓储方 4 需求方
      nickName: '', // 用户昵称
      companyName: null, // 公司名称
      companyLogo: '', // 公司logo
      companyAddress: null, // 公司地址
      detailsAddress: null, // 详细地址
      companyContact: null, // 联系人
      contactTel: null, // 联系电话
      taxpayerNumber: null, // 统一社会信用代码
      bankAccount: null, // 银行账号
      openingBank: null, // 开户行
      transportMode: [], // 运输方式 1水路 2铁路 3公路
      transportRange: null, // 运输范围 1国际 2全国 3跨省区 4省内
      warehouseType: [], // 仓库类型
      casingVolume: null, // 罐体容积
      tanksCount: null, // 储罐数量
      storageType: [], // 可存储类型 1原油 2成品油 3固态化工品 4普通散货
      owendStorageArea: null, // 自有仓储面积 1 4000以下 2 4000-1000 3 10000-20000 4 20000-80000 5 80000-200000 6 200000以上
      ownedVehicle: null, // 自有车辆 1：30以下 2：30-80 3：80-150 4：150-400 5：400-1500 6：1500
      businessYears: null, // 营业年限 1：不满一年 2：一年以上 3：两年以上 4：三年以上
      informatization: null, // 信息化情况 1：部分网络化管理 2：全部网络化管理 3：未建立网络化管理
      electronicWaybillManagement: null, // 电子运单管理 1:90%以上 2：70%以上 3：50%以上 3：30%以上  4：无
      customerInquirySystem: null, // 客户查询系统 1：建立自动化查询系统 2：建立人工查询系统 3：无
      companyTel: null, // 公司固话
      mainBusiness: null, // 主营业务
      licenseUrl: '', // 营业执照（修改需审核）
      permitUrl: '', // 银行开户许可证
      vehicleOperationUrl: '', // 车辆营运证
      roadTransportUrl: '', // 道路运输许可证
      safeTransportUrl: '', // 安全运输许可证
      authStatus: '1', //  认证状态 1：待提交 2：审核中  3：审核通过
      returnReasons: [] // 退回原因
    }

    this.rules = {
      companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
      companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
      companyContact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      contactTel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      // taxpayerNumber: [{ required: true, validator: taxpayerNumberRules, trigger: 'blur' }],
      bankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
      openingBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
      transportMode: [{ type: 'array', required: true, message: '请至少选择一个运输方式', trigger: 'change' }],
      transportRange: [{ required: true, message: '请选择运输范围', trigger: 'change' }],
      warehouseType: [{ type: 'array', required: true, message: '请至少选择一个仓库类型', trigger: 'change' }],
      casingVolume: [{ required: true, message: '请输入罐体容积', trigger: 'blur' }],
      tanksCount: [{ required: true, message: '请输入储罐数量', trigger: 'blur' }],
      storageType: [{ type: 'array', required: true, message: '请至少选择一个可存储类型', trigger: 'change' }],
      owendStorageArea: [{ required: true, message: '请选择自有仓储面积', trigger: 'change' }],
      ownedVehicle: [{ required: true, message: '请选择自有车辆', trigger: 'change' }],
      businessYears: [{ required: true, message: '请选择营业年限', trigger: 'change' }],
      informatization: [{ required: true, message: '请选择信息化情况', trigger: 'change' }],
      electronicWaybillManagement: [{ required: true, message: '请选择电子运单管理', trigger: 'change' }],
      customerInquirySystem: [{ required: true, message: '请选择客户查询系统', trigger: 'change' }],
      companyTel: [{ required: true, message: '请输入公司固话', trigger: 'blur' }],
      mainBusiness: [{ required: true, message: '请输入主营业务', trigger: 'blur' }]
      // companyLogo: [{ required: true, validator: companyLogoRules, trigger: 'blur' }], // 公司logo
      // licenseUrl: [{ required: true, validator: licenseRules, trigger: 'blur' }], // 营业执照（修改需审核）
      // permitUrl: [{ required: true, validator: permitValidator, trigger: 'blur' }], // 银行开户许可证
      // vehicleOperationUrl: [{ required: true, validator: vehicleOperationRules, trigger: 'blur' }], // 车辆营运证
      // roadTransportUrl: [{ required: true, validator: roadTransportRules, trigger: 'blur' }], // 道路运输许可证
      // safeTransportUrl: [{ required: true, validator: safeTransportRules, trigger: 'blur' }] // 安全运输许可证
    }
  }
  dataForm;
  rules;
}

export class tableClass {
  constructor() {
    this.table = null
    this.form = null
  }

  // 调用列表参数
  static getTable() {
    if (!this.table) {
      this.table = new TabParam()
    }
    return this.table
  }

  // 调用表单参数
  static getForm() {
    if (!this.form) {
      this.form = new FormParam()
    }
    return this.form
  }

  // 调用表单参数
  static getData() {
    var form = new FormParam()
    return {
      imageUrl: '',
      companyTypeName: ['管理员', '货源企业', '运力企业', '仓储企业', '需求企业'],
      companyTypefile: ['', 'goodsFile', 'transportFile', 'cangchuFile', 'ccneedFile'],
      tjCard: false,
      companyShow: false,
      failCard: false,
      SuccessCard: false,
      renzhenCard: true,
      submitCard: false,
      post_flag: false,
      //  隐藏数据 判断
      showTabXz: '1',
      showTable: '',
      kqrjDisabled: true,
      cgslDisabled: true,
      zyDisabled: true,
      yyDisabled: true,
      failContent: ['公司名称不合法', '统一社会信用代码不合法', '无法找到联系人', '开户行不明确', '营业执照不清晰', '相关证件不清晰'],
      authentication: form.dataForm, // 定义弹框对象
      user: {
        name: '测试',
        userType: null
      },
      biaodanVisible: false,
      yunliVisible: false,
      jiaoyiVisible: false
    }
  }
}
